import { types, getParent, flow, applySnapshot } from 'mobx-state-tree';

export const MsgAmount = types.model('MsgAmount', {
    //resetDate: types.string,
    sentSMS: types.number,
    sentMMS: types.number,    
})
    .views(self => ({
        get loggedinUser() {
            return getParent(self);
        },
        get totalSentMessages(): number {
            return self.sentSMS + self.sentMMS;
        },
    }))
    .actions(self => ({
        updateMsgAmount(json: string) {
            applySnapshot(self, JSON.parse(json));
        },

        setTest() {
            //self.resetDate = '20180224';
            self.sentSMS = 48;
            self.sentMMS = 18;            
        },
        
    }));

export default MsgAmount;


// WEBPACK FOOTER //
// ./src/models/MsgAmount.ts